import { MinimalProduct, SevDeskProduct, UsedProduct } from "../types/product";

export const filterProducts = (products: MinimalProduct[]) => {
  const sevDeskProducts: SevDeskProduct[] = products
    .filter((product) => product.isSevDeskProduct && product.quantity > 0)
    .map(({ id, name, quantity, description, payExtraQuantity }) => ({
      id: +id,
      name,
      quantity: parseFloat(quantity.toString().replace(",", ".")),
      description,
      payExtraQuantity: parseFloat((payExtraQuantity ?? 0).toString().replace(",", ".")),
    }));

  const usedProducts: UsedProduct[] = products
    .filter((product) => !product.isSevDeskProduct && product.quantity > 0)
    .map(({ id, quantity, payExtraQuantity }) => ({
      productId: id.toString(),
      usedQuantity: parseFloat(quantity.toString().replace(",", ".")),
      payExtraQuantity: parseFloat((payExtraQuantity ?? 0).toString().replace(",", ".")),
    }));

  return { sevDeskProducts, usedProducts };
};
